export var createMuiListOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        padding: {
            paddingTop: spacing(2),
            paddingBottom: spacing(2),
        },
    });
};
//# sourceMappingURL=MuiList.js.map